<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_9"></a>
<p class="noindents" style="margin-top: 8em;">And so adrift in unknown selves we lie</p>
<p class="noindents">Abandoned to dark plucks of circumstance,</p>
<p class="noindents">Not knowing what will come or what we’ll do</p>
<p class="noindents">Or where the tides of sleep will wash us and</p>
<p class="noindents">Shy from the sculling shapes that feed on mind,</p>
<p class="noindents">Feel every certainty drift out of reach</p>
<p class="noindents">And sigh and hold each other, tryst with touch</p>
<p class="noindents">To share what is not shareable, and know</p>
<p class="noindents">The jerking terror of time’s undertow</p>
<p class="noindents">And madly try to dream ourselves a beach.</p>
<a id="page_10"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Dedication02.vue?ab9d7502